import { useState, forwardRef } from "react";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import axios from "axios";
import CircularProgress from "@mui/material/CircularProgress";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert, { AlertProps } from "@mui/material/Alert";

const Contact = () => {
  const Alert = forwardRef<HTMLDivElement, AlertProps>(function Alert(
    props,
    ref
  ) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const [formState, setFormState] = useState<{
    name: string;
    email: string;
    message: string;
  }>({
    name: "",
    email: "",
    message: "",
  });
  const [loading, setLoading] = useState<Boolean>(false);
  const [open, setOpen] = useState<any>(false);

  const handleClose = (
    event: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormState({
      name: e.target.value,
      email: formState.email,
      message: formState.message,
    });
  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormState({
      name: formState.name,
      email: e.target.value,
      message: formState.message,
    });
  };

  const handleMessageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormState({
      name: formState.name,
      email: formState.email,
      message: e.target.value,
    });
  };

  const handleEmailSubmit = (event: React.SyntheticEvent) => {
    event.preventDefault();
    setLoading(true);
    const body = {
      senderName: formState.name,
      senderEmail: formState.email,
      receiverEmail: "rr692@cornell.edu",
      message: formState.message,
    };

    axios
      .post("https://www.michaelscharf.dev/email", body)
      .then((res) => {
        setLoading(false);
        setOpen(true);
        console.log(res);
      })
      .catch((err) => {
        setLoading(false);
        alert(
          "Sorry! Something went wrong. Please send me a message on LinkedIn and let me know my contact form isn't working :("
        );
        console.log(err);
      });
  };
  return (
    <div id="Contact" className="mb-12">
      <Typography
        variant="h6"
        noWrap
        component="h6"
        sx={{
          color: "white",
          textDecoration: "none",
          fontSize: "5vh",
          display: "flex",
          justifyContent: "center",
          marginBottom: "3vh",
          fontWeight: "300",
        }}
      >
        Contact
      </Typography>
      <div className="flex justify-center flex-col items-center w-full flex-wrap md:px-12 ">
        <p className="mb-4 w-4/5 text-center">
          Feel free to use this form to contact me!
        </p>
        <form
          onSubmit={handleEmailSubmit}
          className="w-3/5 flex items-center flex-col gap-6 mt-4"
          action=""
        >
          <TextField
            fullWidth
            id="outlined-basic"
            label="Name"
            variant="outlined"
            value={formState.name}
            onChange={handleNameChange}
          />
          <TextField
            fullWidth
            id="outlined-basic"
            label="Email"
            variant="outlined"
            value={formState.email}
            onChange={handleEmailChange}
          />
          <TextField
            fullWidth
            id="outlined-basic"
            label="Message"
            variant="outlined"
            multiline
            rows={6}
            value={formState.message}
            onChange={handleMessageChange}
          />
          <Button type="submit" className="w-1/5" variant="contained">
            Submit
          </Button>
          {loading ? <CircularProgress></CircularProgress> : ""}
        </form>
        <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
          <Alert
            onClose={handleClose}
            severity="success"
            sx={{ width: "100%" }}
          >
            Message sent! I will get back to you shortly 🙂
          </Alert>
        </Snackbar>
      </div>
    </div>
  );
};

export default Contact;
